export const checkForEnter = (e: React.KeyboardEvent<HTMLInputElement>, callback: () => void): void => {
  if (e.key === "Enter") {
    // props.onSubmit(props.escapeSearchValue ? scrubUserInput(inputField.current.value) : inputField.current.value);
    callback();
  }
};
